export default __webpack_public_path__ + "static/media/vip-banner-ms.b750dde2.webp";